var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserTieSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0768 10C28.0768 15.5234 23.6354 20 18.1554 20C12.6754 20 8.23402 15.5234 8.23402 10C8.23402 4.47734 12.6754 0 18.1554 0C23.6354 0 28.0768 4.47734 28.0768 10ZM17.0005 28.0625L14.4349 23.75H21.8759L19.3103 28.0625L21.8914 37.7422L24.9531 25.1484C30.937 26.0859 35.5179 31.3047 35.5179 37.6016C35.5179 38.9219 34.4482 40 33.1383 40H3.1741C1.85874 40 0.792969 38.9219 0.792969 37.6016C0.792969 31.3047 5.37309 26.0859 11.3577 25.1484L14.4194 37.7422L17.0005 28.0625Z",
    fill: "#F4730E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7249,
    height: 40,
    fill: "white",
    transform: "translate(0.792969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTieSolid);
export default __webpack_public_path__ + "static/media/user-tie-solid.ccb35ccca28cd9f32ebe30cfd237d7c8.svg";
export { ForwardRef as ReactComponent };